<div class="event-list">
  <div *ngIf="shouldShowNoEventsInfo" class="event-list__no-events-info">
    <!--  TODO: improve message and style -->

    <img src="/assets/icons/info-icon.svg" class="event-list__no-events-info-icon">
    <span>
      Looks like there are no events on selected but you can have a look at your upcoming events
    </span>
  </div>
  <div>
    <div *ngFor="let event of events; trackBy: trackById" class="mb-3">
      <div class="event-list__date-marker" *ngIf="shouldShowMarker(event)">
        <span class="event-list__date-marker-title">
          {{ dateFormatted(event.event_start) }}
        </span>
      </div>
      <app-event
        appScrollTo
        [scrollWhen]="changesDetected && isActive(event)"
        [event]="event"
        [minified]="true"
        [background]="false"
        [isActive]="isActive(event)"
        [title]="('view' | t) + ' ' + event.event_name"
        [hasClickEvent]="true"
        (eventClicked)="handleEventClick(event, $event)"
        (goToEventPageClicked)="goToEventPageClicked.emit($event)"
        class="event-list__event js-event-list-event"
      ></app-event>
      <app-event
        *ngIf="selectedEvent?.event_id === event.event_id"
        [event]="selectedEvent"
        [inline]="true"
        [minified]="false"
        class="mt-3"
        [class.is-mobile]="isMobile$ | ngrxPush"
      ></app-event>
    </div>
  </div>
</div>
